export default __webpack_public_path__ + "static/media/ride.1a602fc2.png";